import React from "react";
import { Select, Typography } from "antd";

const { Text } = Typography;

export default function PaymentMethodSelect({ value, onChange }) {
  return (
    <div style={{ marginTop: 16 }}>
      <Text>Selecciona el método de pago:</Text>
      <Select
        value={value}
        size="large"
        style={{ width: "100%", marginTop: 8 }}
        onChange={onChange}
        options={[
          { value: "bravos", label: "Pagar con bravos" },
          { value: "cash", label: "Pagar con efectivo" },
        ]}
      />
    </div>
  );
}
